import Splitting from 'splitting';

export default class Split extends HTMLElement {
  constructor() {
    super();

    // UI
    this.$target = this.querySelector('[data-split-target]');

    // Data
    this.splitType = this.dataset.splitType ? this.dataset.splitType : 'lines';
  }

  // =============================================================================
  // Lifecycle methods
  // =============================================================================
  connectedCallback() {
    this.bindEvents();
  }

  disconnectedCallback() {
    this.unbindEvents();
  }

  // =============================================================================
  // Events
  // =============================================================================
  bindEvents() {
    // console.log('bindEvents');
    this.split();
  }

  unbindEvents() {
    // console.log('unbindEvents');
  }

  ///////////////
  // Methods
  ///////////////
  split() {
    Splitting({ target: this.$target, by: this.splitType });
  }
}
